export const LANG_ENGLISH = 'EN';
export const LANG_FRENCH = 'FR';

export const CONSTANT = {
  KEYS: {
    USER_STATUS: {
      PENDING_APPROVAL: 'PENDING_APPROVAL',
      APPROVED: 'APPROVED'
    },
    ROLES: {
      ADMIN: 'ADMIN',
      SALES_REP: 'SALES_REP',
      SALES_MANAGER: 'SALES_MANAGER',
      SALES_SUPPORT: 'SALES_SUPPORT',
      ORDER_FULFILLMENT: 'ORDER_FULFILLMENT'
    }
  },
  ROLES: {
    ADMIN: 1,
    SALES_REP: 2,
    SALES_MANAGER: 3,
    SALES_SUPPORT: 5,
    PROPOSAL_HOUSE: 6,
    ORDER_FULFILLMENT: 10
  },
  CHANNELS: {
    ADT_SALES: 7,
    BCX_CARE: 14,
    BCX_LOYALTY: 15,
    CORP_STORE: 2,
    DEALER: 9,
    INKEROS_EAST: 22,
    INKEROS_WEST: 21,
    ISS_ALBERTA: 17,
    ISS_BRITISH_COLUMBIA: 5,
    ISS_ONTARIO: 11,
    LTS_TBS: 24,
    NGM_NEW_GROWTH_MARKETS: 18,
    SBS_DIRECT_SALES_AB: 3,
    SBS_DIRECT_SALES_BC: 19,
    SBS_DIRECT_SALES_EAST: 20,
    SBS_ISS_QC_ATL: 12,
    SBS_TI_SALES: 8,
    TELUS_MID_MARKET: 23,
    TELUS_MID_MARKET_QUEBEC: 4,
    TQ_PARTENAIRE: 10,
    TRL_BCX: 13,
    CSD: 95,
    NBD: 96,
    ADT: 97,
    HEALTH: 98
  }
};

export const RECAPTCHA_SITE_KEY = '6Ld-Tf0UAAAAAM3p1dA7bIXA_TcdCS4SrR_ZEysy';

export const ADMIN_EMAIL = 'tiffany.motayne@telus.com';

export const ROLES = [
  'SALES_REP',
  'SALES_MANAGER',
  'SALES_SUPPORT',
  'ORDER_FULFILLMENT'
];

export const CHANNEL = {
  corpStore: 'CORP_STORE',
  SBS: 'SBS',
  BSE_BSW: 'BSE_BSW',
  LSS: 'LSS',
  TAM: 'TAM',
  ADT_SALES: 'ADT_SALES',
  TIP_SALES: 'TIP_SALES',
  Dealer: 'DEALER',
  TQ_PARTENAIRE: 'TQ_PARTENAIRE',
  ISS_EAST: 'ISS_EAST'
};

export const partnerNames = [
  { id: 1, value: 1, text: 'Connect 6' },
  { id: 2, value: 2, text: 'PI Telecom' },
  { id: 3, value: 3, text: 'Legacy' },
  { id: 4, value: 4, text: 'CB Telecom' },
  { id: 5, value: 5, text: 'Contractuel' },
  { id: 6, value: 6, text: 'Unimarketing' },
  { id: 7, value: 7, text: 'Alarm Direct' },
  { id: 8, value: 8, text: 'Clario' },
  { id: 9, value: 9, text: 'Millenium One' },
  { id: 10, value: 10, text: 'Sécure Assure' },
  { id: 11, value: 11, text: 'Tech Seics' }
];

export const channelOutletMapping = {
  'SMB Retention 1 to 30 1A': ['1100052600'],
  'SMB Retention 1 to 30 1B': ['1100052601'],
  'SMB Retention 1 to 30 1C': ['1100052602'],
  'SMB Retention 1 to 30 1D': ['1100052603'],
  'SMB Retention 30 to 100 2A': ['1100052604'],
  'SMB Retention 30 to 100 2B': ['1100052605'],
  'SMB Retention 30 to 100 2C': ['1100052606'],
  'SMB Retention 30 to 100 2D': ['1100052607'],
  'SMB Growth Sales W 1A': ['1100052608'],
  'SMB Growth Sales W 1B': ['1100052609'],
  'SMB Growth Sales W 1C': ['1100052610'],
  'SMB Growth Sales W 1D': ['1100052611'],
  'SMB Growth Sales W 2A': ['1100052612'],
  'SMB Growth Sales W 2B': ['1100052613'],
  'SMB Growth Sales W 2C': ['1100052614'],
  'SMB Growth Sales W 2D': ['1100052615'],
  'SMB Growth Sales E 1A': ['1100052616'],
  'SMB Growth Sales E 1B': ['1100052617'],
  'SMB Growth Sales E 1C': ['1100052618'],
  'SMB Growth Sales E 1D': ['1100052619'],
  'SMB Growth Sales E 1E': ['1100052620'],
  'SMB Growth Sales E 2A': ['1100052621'],
  'SMB Growth Sales E 2B': ['1100052622'],
  'SMB Growth Sales E 2C': ['1100052623'],
  'SMB Growth Sales E 2D': ['1100052624'],
  'SMB Growth Sales E 2E': ['1100052625'],
  'SMB Growth Sales E 3A': ['1100052626'],
  'SMB Growth Sales E 3B': ['1100052627'],
  'SMB Growth Sales E 3C': ['1100052628'],
  'SMB Growth Sales E 3D': ['1100052629'],
  'SMB Growth Sales E 4A': ['1100052630'],
  'SMB Growth Sales E 4B': ['1100052631'],
  'SMB Growth Sales E 4C': ['1100052632'],
  'SMB Growth Sales E 4D': ['1100052633'],
  'SMB Growth Sales E 4E': ['1100052634'],
  'SMB Growth Sales 30 to 100 1A': ['1100052635'],
  'SMB Growth Sales 30 to 100 1B': ['1100052636'],
  'SMB Growth Sales 30 to 100 1C': ['1100052637'],
  'SMB Growth Sales 30 to 100 1D': ['1100052638'],
  'SMB Growth Sales 30 to 100 2A': ['1100052639'],
  'SMB Growth Sales 30 to 100 2B': ['1100052640'],
  'SMB Growth Sales 30 to 100 2C': ['1100052641'],
  'SMB L&R 1': ['1100052642'],
  'SMB L&R 2': ['1100052643'],
  'SMB L&R 3': ['1100052644'],
  'SMB L&R 4': ['1100052645'],
  'SMB L&R 5': ['1100052646'],
  'SMB L&R TI': ['1100052647'],
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB New Growth Market 1': ['1100050829'],
  'SMB New Growth Market 2': ['1100052073'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737'],
  'SMB Growth Sales Advance 1': ['1100052968'],
  'SMB Growth Sales Advance 2': ['1100052976']
};

export const sof1HomeUrl = 'https://www.mysofportal.com';
export const sof2HomeUrl = 'https://www.mysalesorders.com';
